export const V1_SET_DEPARTURE_AIRPORT = 'V1_SET_DEPARTURE_AIRPORT'

export default data => {
  return {
    type: V1_SET_DEPARTURE_AIRPORT,
    data,
  }
}
